import { render, staticRenderFns } from "./allPro.vue?vue&type=template&id=4220d1ac&"
import script from "./allPro.vue?vue&type=script&lang=js&"
export * from "./allPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports